import { Scene, Mesh, TransformNode, PhysicsShapeMesh, PhysicsShapeConvexHull, Color3, PhysicsBody, PhysicsMotionType, AnimationGroup, Matrix, Vector3, } from '@babylonjs/core';
import { Tool } from './tools';
// 将一个transformNode / Group的Mesh遍历出来，并保存到一个数组中。
//可以用于批量设置材质，发射和接收阴影
//可以用于合并网格
export class BabylonTools {
    public static flatFromGroup(node: TransformNode, meshs: Mesh[]) {
        if (!node) {
            return;
        }
        if (node instanceof Mesh) {
            // console.log("----- mesh: "+node.name);
            meshs.push(node);
        }
        let c = node.getChildren();
        if (!c) {
            return;
        }
        // console.log(node.name);
        for (let i = 0; i < c.length; i++) {
            if (c[i] instanceof TransformNode) {
                this.flatFromGroup(c[i] as TransformNode, meshs);
            }
            if (c[i] instanceof Mesh) {
                meshs.push(c[i] as Mesh);
            }
        }
    }
    public static bindBodyShape(mesh: Mesh, shapeType: number = 0, scene: Scene, color: Color3 = new Color3(1, 0, 0)) {
        let shape;
        if (shapeType == 0) {
            shape = new PhysicsShapeMesh(mesh, scene);
        } else {
            shape = new PhysicsShapeConvexHull(mesh, scene);
        }
        var body = new PhysicsBody(mesh, PhysicsMotionType.DYNAMIC, false, scene);

        shape.material = { friction: 0, restitution: 0 };
        body.shape = shape;
        body.setMassProperties({
            mass: 0,
        });
    };
    public static cloneAnimations(groups: AnimationGroup[]) {
        let temp = [];
        for (let i = 0; i < groups.length; i++) {
            const a = groups[i] as AnimationGroup;
            const b = a.clone(a.name + "_" + Tool.randomStr(6));
            temp.push(b)
        }
        return temp;
    }
    /**
     * 
     * @param rect3D 
     * @param rectMap 
     * @returns 
     *  ----------------  用Matrix对象实现不同坐标系之间向量和坐标的转换 -----------------
     * 通过计算两个坐标系在X和Z轴上的缩放比例和偏移量,设置Matrix对象的值,实现了两个坐标系之间的转换关系。
     * 然后用Vector3.TransformCoordinates方法可以实现坐标的转换,如把rect3D坐标系下的(-75, 0, 58)转换到rectMap坐标系下
     * test code
     rect3D = { start: new Vector3(70, 0, -23), end: new Vector3(-125, 0, 68), rangeX: -197, rangeZ: 91 }; // (x+)-(x-); (z+)-(z-)
     rectMap = { start: new Vector3(0 - 50, 0, 26 - 50), end: new Vector3(100 - 50, 0, 73 - 50), rangeX: 100, rangeZ: 47 }; // top和left的原点在mc的矩形中心
     this.mat = this.getMatrix(rect3D, rectMap);
     let miniMapPosition = Vector3.TransformCoordinates(player.position, this.mat);
     */
    public static getMatrix(rect3D: { start: Vector3, end: Vector3, rangeX: number, rangeZ: number }, rectMap: { start: Vector3, end: Vector3, rangeX: number, rangeZ: number }) {
        // 创建一个Matrix对象
        let transformMatrix = new Matrix();

        // 计算两个坐标系在X和Z轴上的缩放比例
        let scaleX = rectMap.rangeX / rect3D.rangeX;
        let scaleZ = rectMap.rangeZ / rect3D.rangeZ;
        console.log(scaleX, scaleZ)

        // 计算两个坐标系在X和Z轴上的偏移量 
        let offsetX = rectMap.start.x - scaleX * rect3D.start.x;
        let offsetZ = rectMap.start.z - scaleZ * rect3D.start.z;

        // 设置Matrix对象的值
        let m = transformMatrix.m as number[];
        m[0] = scaleX;
        m[1] = 0;
        m[2] = 0;
        m[3] = 0;

        m[4] = 0;
        m[5] = 1;
        m[6] = 0;
        m[7] = 0;

        m[8] = 0;
        m[9] = 0;
        m[10] = scaleZ;
        m[11] = 0;

        m[12] = offsetX;
        m[13] = 0;
        m[14] = offsetZ;
        m[15] = 1;
        return transformMatrix;
    }
}